import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'PlantLayoutEditor',
  //   description: 'description of PlantLayoutEditor',
  //   url: '/plant-layout-editor',
  // },
];

export default help;
